import React from 'react';
import { Drawer, Button } from 'antd';
import Buttons from '../Buttons/Buttons';
import { RiCloseLine } from 'react-icons/ri';
import { translations } from '../../utils/constants';

const CustomModal = ({ isVisible, onClose, title, children, actionText, onAction, loading, language }) => {
  return (
    <Drawer
      title={title}
      visible={isVisible}
      onClose={onClose}
      width={750}
      placement='right'
      closable={true}
      footer={
        <div style={{ textAlign: 'right' }}>
          <Button key='cancel' onClick={onClose} type='default' className='drawer-cancel'>
            {translations[language]?.cancelButton}
          </Button>
          {actionText && (
            <Buttons key='action' onClick={onAction} type='primary' loading={loading} className='Delete-button'>
              {actionText}
            </Buttons>
          )}
        </div>
      }

      className='custom-drawer'
      closeIcon={<span className='custom-close-icon'><RiCloseLine /></span>}
      style={{ zIndex: 1000 }}
    >
      <div className='custom-modal-inner-container'>

        {children}
      </div>
    </Drawer>
  );
};

export default CustomModal;
